"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
var _sendFrom = _interopRequireDefault(require("./sendFrom"));
var _useOrder = require("@/hooks/use-order");
var _default2 = require("../default");
var _pointsMall = require("@/api/pointsMall");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var defaultObj = {
  deliveryType: 'express',
  deliveryMark: '',
  carrierPhone: '',
  deliveryCarrier: '',
  expressCode: '',
  expressNumber: '',
  orderNo: '',
  isSplit: false
};
var _default = exports.default = {
  name: 'orderSend',
  components: {
    SendFrom: _sendFrom.default
  },
  props: {
    orderNo: String
  },
  watch: {},
  data: function data() {
    return {
      formItem: _objectSpread({}, defaultObj),
      modals: false,
      express: [],
      exportTempList: [],
      tempImg: '',
      rules: _default2.postRules
    };
  },
  mounted: function mounted() {},
  methods: {
    checkPermi: _permission.checkPermi,
    //决定这一行的 CheckBox 是否可以勾选
    selectable: function selectable(row, index) {
      if (row.deliveryNum === row.payNum) {
        return false;
      } else {
        return true;
      }
    },
    limitCount: function limitCount(row, i) {
      if (row.num > row.payNum) row.num = row.payNum;
    },
    // 分单发货选择商品
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeRadio: function changeRadio(o) {
      this.formItem = _objectSpread(_objectSpread({}, defaultObj), {}, {
        deliveryType: o
      });
      this.$nextTick(function () {
        this.$refs.formItem.clearValidate();
      });
    },
    // 提交
    putSend: (0, _validate.Debounce)(function (name) {
      var _this = this;
      this.formItem.orderNo = this.orderNo;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _pointsMall.intervalOrderSendApi)(_this.formItem).then(function (async) {
            _this.$message.success('发货成功');
            _this.modals = false;
            _this.$emit('submitFail');
            _this.$refs[name].resetFields();
          });
        } else {
          _this.$message.error('请填写信息');
        }
      });
    }),
    handleClose: function handleClose() {
      this.cancel();
    },
    cancel: function cancel() {
      this.modals = false;
      if (this.formItem.deliveryType !== 'noNeed') this.$refs.formItem.resetFields();
      this.formItem = _objectSpread(_objectSpread({}, defaultObj), {}, {
        expressCode: this.formItem.expressCode
      });
      //this.formItem.type = '1';
      // this.formItem.deliveryType = 'express';
    }
  }
};